'use client';

import Cookie from 'js-cookie';
import { Currency, User } from '@/api/types/public';
import { useEffect } from 'react';
import { CommonCurrencyInfo } from '@/utils/currency/util-currency';
import { useStore } from '@/providers/app-store-provider';

export const useClientDataInit = ({
  token,
  accountInfo,
  currencyInfo,
}: {
  token: string;
  accountInfo: User;
  currencyInfo: CommonCurrencyInfo;
}) => {
  const setCurrency = useStore((state) => state.setCurrency);
  const setUserInfo = useStore((state) => state.setUserInfo);
  const setToken = useStore((state) => state.setToken);

  // 设置 currency 到 cookies 的辅助函数
  const setCurrencyToCookie = (currency: Currency) => {
    if (typeof window !== 'undefined' && currency?.name) {
      Cookie.set('zl-currency', currency.name, { expires: 365, sameSite: 'lax', path: '/' });
    }
  };

  /**
   * TODO: 这里本不需要执行 setStore 的操作
   *      但是 setStore 里会有副作用（localStorage操作），因此这里需要再执行一次，但是不会触发状态变化
   *      建议后续把副作用改在 useEffect 中执行
   */
  useEffect(() => {
    // test
    window._now = Date.now();
    // Handle currency cookie
    if (currencyInfo) {
      switch (currencyInfo.source) {
        case 'URL':
        case 'IP':
          setCurrency(currencyInfo.currency);
          setCurrencyToCookie(currencyInfo.currency);
          break;
        case 'Cookie':
        case 'Env':
          setCurrency(currencyInfo.currency);
          break;
        default:
          break;
      }
    }

    // 设置用户信息
    if (accountInfo) {
      setUserInfo(accountInfo);
      if (token) {
        setToken(token);
      }
    }
  }, []);
};
